import { render } from "./AlmCountCellRenderer.vue?vue&type=template&id=0209f38d&ts=true"
import script from "./AlmCountCellRenderer.vue?vue&type=script&lang=ts"
export * from "./AlmCountCellRenderer.vue?vue&type=script&lang=ts"

import "./AlmCountCellRenderer.vue?vue&type=style&index=0&id=0209f38d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__